import {
    GetPosterListQuery,
    GetPosterListQueryVariables
} from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import { usePagination, DEFAULT_ITEMS_PER_PAGE } from '../pagination'
import { getPosterListQuery } from './graphql/query'

const getSpace = (data) => getNodes(data?.event?.posterSpaces)?.[0]
const getList = (data) => getNodes(getSpace(data)?.posters)
const getPageInfo = (data) => getSpace(data)?.posters?.pageInfo
const getTotalCount = (data) => getSpace(data)?.posters?.totalCount

export const usePosterItems = (
    { ...variables }: GetPosterListQueryVariables
) => usePagination<GetPosterListQuery, GetPosterListQueryVariables>({
    query: getPosterListQuery,
    initPage: 1,
    initItemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    getList,
    getPageInfo,
    getTotalCount,
    variables,
})
